module.exports = __webpack_public_path__ + "6b356579d4e65e9a17ad317de41a406c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/ch_grid_9.png
// module id = 137
// module chunks = 1